<script lang="ts">
  import Link from "svelte-link";
  import { href, LastSeen, Typing } from "../../../../utils/Constant/Constant";
  import { Col, Image } from "sveltestrap";
  import { isOpens } from "../../../../store";
  import data from "../../../../Data/Chat/Chat.json";
  import ChatHistory from "./ChatHistory.svelte";
  let imgPath: string = "/assets/images/user";
  const handleList = () => {
    isOpens.update((value) => (value = !value));
  };
</script>

<Col class="pr-xl-0 chat-right-aside">
  <div class="chat">
    <div class="media chat-header clearfix">
      <Image class="rounded-circle" src="{imgPath}/8.jpg" alt="" />
      <div class="media-body">
        <div class="about">
          <div class="name">
            Kori Thomas  
            <span class="font-primary f-12">{Typing}</span>
          </div>
          <div class="status digits">{LastSeen}</div>
        </div>
      </div>
      <ul class="list-inline chat-menu-icons float-end">
        {#each data.icondata as chatItem}
          <li class="list-inline-item">
            <Link {href}><i class={chatItem.icon} /></Link>
          </li>
        {/each}
        <li class="list-inline-item toogle-bar">
          <Link {href} on:click={handleList}><i class="icon-menu" /></Link>
        </li>
      </ul>
    </div>
  </div>
  <ChatHistory />
</Col>
